export const WATCH_BRANDS_MODELS_BRACELETS = {
  "Rolex": {
    "Oyster Perpetual": {
      "diameters": [28, 31, 34, 36, 41],
      "bracelets": ["Oyster"]
    },
    "Datejust": {
      "diameters": [26, 31, 36, 41],
      "bracelets": ["Oyster", "Jubilee"]
    },
    "Day-Date": {
      "diameters": [36, 40],
      "bracelets": ["President"]
    },
    "Submariner": {
      "diameters": [41],
      "bracelets": ["Oyster"]
    },
    "GMT-Master II": {
      "diameters": [40],
      "bracelets": ["Oyster", "Jubilee"]
    },
    "Explorer": {
      "diameters": [36, 39],
      "bracelets": ["Oyster"]
    },
    "Yacht-Master": {
      "diameters": [37, 40, 42],
      "bracelets": ["Oyster", "Oysterflex"]
    }
  },
  "Chopard": {
    "Happy Sport": {
      "diameters": [30, 36, 40],
      "bracelets": ["Bransoleta stalowa", "Pasek skórzany"]
    },
    "Mille Miglia": {
      "diameters": [39, 42, 44],
      "bracelets": ["Pasek gumowy"]
    },
    "L.U.C": {
      "diameters": [39, 40, 42],
      "bracelets": ["Bransoleta metalowa", "Pasek skórzany"]
    },
    "Alpine Eagle": {
      "diameters": [36, 41, 44],
      "bracelets": ["Bransoleta zintegrowana"]
    }
  },
  "Cartier": {
    "Tank Must": {
      "diameters": [29, 34],
      "bracelets": ["Bransoleta metalowa", "Pasek skórzany"]
    },
    "Tank Française": {
      "diameters": [25, 30, 37],
      "bracelets": ["Bransoleta metalowa", "Pasek skórzany"]
    },
    "Santos de Cartier": {
      "diameters": [35, 40, 48],
      "bracelets": ["Bransoleta metalowa", "Pasek skórzany"]
    },
    "Ballon Bleu": {
      "diameters": [28, 33, 36, 40, 42],
      "bracelets": ["Bransoleta metalowa", "Pasek skórzany"]
    },
    "Pasha de Cartier": {
      "diameters": [35, 41, 42],
      "bracelets": ["Bransoleta metalowa", "Pasek skórzany"]
    }
  },
  "Audemars Piguet": {
    "Royal Oak": {
      "diameters": [33, 34, 37, 39, 41],
      "bracelets": ["Bransoleta zintegrowana"]
    },
    "Royal Oak Offshore": {
      "diameters": [42, 44],
      "bracelets": ["Bransoleta metalowa", "Pasek gumowy", "Pasek skórzany"]
    },
    "Code 11.59": {
      "diameters": [38, 41],
      "bracelets": ["Pasek skórzany"]
    }
  },
  "Patek Philippe": {
    "Nautilus": {
      "diameters": [35, 40, 42],
      "bracelets": ["Bransoleta zintegrowana"]
    },
    "Aquanaut": {
      "diameters": [36, 39, 42],
      "bracelets": ["Pasek kompozytowy"]
    },
    "Calatrava": {
      "diameters": [36, 37, 38, 39],
      "bracelets": ["Pasek skórzany"]
    },
    "Gondolo": {
      "diameters": [30, 32, 36, 38, 40],
      "bracelets": ["Pasek skórzany", "Bransoleta metalowa"]
    }
  }
};
